import { functions } from '../../firebase/firebase';

const state = {
  logoAnimComp: false,
  letsBuild: false,
  loading: false,
  email: '',
};

const getters = {
  getLogoAnimComp: (state) => state.logoAnimComp,
  getLetsBuild: (state) => state.letsBuild,
  getLoading: (state) => state.loading,
  getEmailRes: (state) => state.email,
};

const actions = {
  logoAnimComp({ commit }) {
    commit('setLogoAnimComp', true);
  },
  letsBuild({ commit }) {
    commit('setLetsBuild');
  },
  loadingAction({ commit }, boolean) {
    commit('setLoading', boolean);
  },
  emailAction({ commit, dispatch }, object) {
    const { email, message } = object;
    if (email === '' || message === '') {
      return;
    }
    dispatch('loadingAction', true);
    const sendEmail = functions.httpsCallable('sendEmail');
    sendEmail(object)
      .then(() => {
        commit('setEmail', 'Message sent!');
        dispatch('loadingAction', false);
      })
      .catch((error) => {
        commit('setEmail', error);
        dispatch('loadingAction', false);
      });
  },
};

const mutations = {
  setLogoAnimComp: (state, logoAnimComp) => (state.logoAnimComp = logoAnimComp),
  setLetsBuild: (state) => (state.letsBuild = !state.letsBuild),
  setLoading: (state, boolean) => (state.loading = boolean),
  setEmail: (state, res) => (state.email = res),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
